<template>
  <div class="collapsibleFormInputContainer">
    <el-tabs v-model="nameTab"
             @tab-click="handleTab">
      <el-tab-pane label="CREAR ZONA" name="createZone">
        <div class="block">
          <el-form class="form-map-main"
                   ref="formCreate">
            <el-form-item label="NOMBRE"
                          prop="zoneName">
              <el-input v-model="form.zoneName" @blur="lostFocus"
                        placeholder="Nombre zona"/>
            </el-form-item>
            <div v-show="this.errorsForm.zoneName != ''">
                <span class="alertForm">
                  <i class="el-icon-warning-outline"></i>
                  &#160; {{this.errorsForm.zoneName}}
                </span>
            </div>
            <p></p>
            <el-form-item label="REGIÓN">
              <BaseSelectRegion @sendRegion="receiveRegionId">
              </BaseSelectRegion>
              <div v-show="this.errorsForm.select != ''">
                <span class="alertForm">
                  <i class="el-icon-warning-outline"></i>
                  &#160; {{this.errorsForm.select}}
                </span>
              </div>
            </el-form-item>
            <p class="titleWindows">
              <i class="el-icon-time"></i>&#160;&#160;&#160;CREACIÓN VENTANA HORARIA
            </p>
            <el-form-item>
              <el-radio-group v-model="form.radio" @change="changeOptionDay">
                <el-radio
                  label="Todos los días"/>
                <el-radio
                  label="Algunos días"/>
                <!-- PENDIENTE POR FALTA DE SERVICIO
                <el-radio label="Fecha específica"/>
                -->
              </el-radio-group>
            </el-form-item>
            <el-form-item label="Fecha">
              <div v-if="form.radio === 'Algunos días'">
                <el-select
                  v-model="form.selected"
                  value="form.select"
                  :disabled="form.radio !== 'Algunos días'"
                  placeholder="Fecha"
                  @change="valueOption"
                  multiple>
                  <el-option
                    v-for="day in days"
                    :key="day.value"
                    :label="day.label"
                    :value="day.value"/>
                </el-select>
                <div v-show="this.errorsForm.selected != ''">
                  <span class="alertForm">
                    <i class="el-icon-warning-outline"></i>
                    &#160; {{this.errorsForm.selected}}
                  </span>
                </div>
              </div>
              <div v-else>
                <el-date-picker
                  value-format="yyyy-MM-dd"
                  @change="datePickerVal"
                  style="width: 100%;"
                  type="dates"
                  v-model="form.date"
                  placeholder="Fecha"
                  :disabled="form.radio !== 'Fecha específica'">
                </el-date-picker>
              </div>
            </el-form-item>
            <el-form-item label="Horario">
              <p></p>
              <el-row :gutter=20>
                <el-col :span="12">
                  <el-time-picker
                    @change="lostInit"
                    v-model="form.init"
                    value-format="HH:mm"
                    format="HH:mm"
                    placeholder="Hora de inicio"
                    :disabled="form.radio.length === 0"/>
                    <div v-show="this.errorsForm.init != ''">
                      <span class="alertForm">
                        <i class="el-icon-warning-outline"></i>
                        &#160; {{this.errorsForm.init}}
                      </span>
                    </div>
                    <div v-show="this.errorsForm.initValidate != ''">
                      <span class="alertForm">
                        <i class="el-icon-warning-outline"></i>
                        &#160; {{this.errorsForm.initValidate}}
                      </span>
                    </div>
                </el-col>
                <el-col :span="12">
                  <el-time-picker
                    @change="lostFinish"
                    v-model="form.finish"
                    value-format="HH:mm"
                    format="HH:mm"
                    placeholder="Hora de termino"
                    :disabled="form.radio.length === 0"/>
                    <div v-show="this.errorsForm.finish != ''">
                      <span class="alertForm">
                        <i class="el-icon-warning-outline"></i>
                        &#160; {{this.errorsForm.finish}}
                      </span>
                    </div>
                    <div v-show="this.errorsForm.finishValidate != ''">
                      <span class="alertForm">
                        <i class="el-icon-warning-outline"></i>
                        &#160; {{this.errorsForm.finishValidate}}
                      </span>
                  </div>
                </el-col>
              </el-row>
            </el-form-item>
          </el-form>
          <el-row>
            <el-col :span=24>
              <div v-show="this.timeWindows.length != 0" class="windowsCreated">
                <p class="titleWindowsList">VENTANAS CREADAS</p>
                <ul class="windowsList">
                  <li v-for="(item, i) in this.timeWindows" v-bind:key="item.timeWindows.id">
                    <span style="color: #AAD500; width: 40px; display: block; float: left">
                      DIAS :
                    </span>
                    <span style="width: 100px; display: block; float: left">
                      {{ item.timeWindows.days | daysFormat }}
                    </span>
                    <span style="color: #AAD500;width: 50px; display: block; float: left">
                      DESDE :
                    </span>
                    <span style="width: 60px; display: block; float: left">
                      {{item.timeWindows.time_window.time_init | dateFormat}}
                    </span>
                    <span style="color: #AAD500; width: 50px; display: block; float: left">
                      HASTA  :
                    </span>
                    <span style="width: 60px; display: block; float: left">
                      {{item.timeWindows.time_window.time_finish | dateFormat}}
                    </span>
                    <el-button style="padding: 0; color: #F5A623"
                               type="text"
                               class="el-icon-delete"
                               @click="deleteWindows(i)">
                    </el-button>
                  </li>
                </ul>
              </div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span=8>
              <el-button type="text" v-if="loadingCreateWindows" class="primary" size="mini">
                <i class="el-icon-loading"></i>&#160;&#160;&#160;CARGANDO
              </el-button>
              <el-button v-else class="primary colorBtn" size="mini"
                         :disabled="form.radio.length === 0"
                         @click="submit">CREAR VENTANA
              </el-button>
            </el-col>
            <el-col :span=8>
              <el-button v-show="timeWindows.length > 0"
                         class="primary colorBtnDraw parpadeo"
                         size="mini"
                         @click="addPoligon">
                <i class="el-icon-edit"></i>DIBUJAR ZONA
              </el-button>
            </el-col>
            <el-col :span="8">
              <el-button v-show="timeWindows.length > 0"
                         @click="deletePolyMap"
                         class="colorBtn primary"
                         size="mini">
                BORRAR DIBUJO
              </el-button>
            </el-col>
          </el-row>
          <p></p>
          <el-row>
            <el-col :span=12>
              <div v-show="showAddZone">
                <el-button v-if="loadCreateZone"
                           type="text"
                           class="primary"
                           size="mini">
                  <i class="el-icon-loading"></i>&#160;&#160;&#160;CREANDO ZONA
                </el-button>
                <el-button v-else
                           class="colorBtn primary"
                           size="mini"
                           @click="clickSendZone">AGREGAR ZONA RESTRICCIÓN
                </el-button>
              </div>
            </el-col>
          </el-row>
        </div>
      </el-tab-pane>
      <el-tab-pane label="GESTIÓN ZONA" name="editZone">
        <el-button type="text" v-if="loadingTable" class="primary" size="mini">
          <i class="el-icon-loading"></i>&#160;&#160;&#160;CARGANDO
        </el-button>
        <el-table
          :data="dataZones"
          style="width: 100%"
          size="mini"
          max-height="300">
          <el-table-column
            prop="name"
            label="NOMBRE"
            min-width="90">
          </el-table-column>
          <el-table-column
            label="ESTADO"
            min-width="40">
            <el-switch
              slot-scope="scope"
              @change="changeStatus(scope.row)"
              style="height: 18px; width: 30px;"
              v-model="scope.row.active"
              active-color="#AAD500"
              inactive-color="#a5a5a5">
            </el-switch>
          </el-table-column>
          <el-table-column
            min-width="30">
            <el-button
              slot-scope="scope"
              type="text"
              style="color: #F5A623"
              icon="el-icon-delete"
              @click="deleteZone(scope.row)">
            </el-button>
          </el-table-column>
          <el-table-column
            min-width="30">
            <el-button
              slot-scope="scope"
              size="mini"
              type="text"
              style="color: #AAD500"
              @click="showZone(scope)">
              <span style="font-size: 12px;">VER</span>
            </el-button>
          </el-table-column>
        </el-table>
      </el-tab-pane>
      <el-tab-pane v-if="showDetail === true" label="DETALLE ZONA" name="detail">
        <el-row>
          <el-col :span=24>
            <div class="windowsCreated">
              <p class="titleWindowsListDetail">{{this.restrictionsName}}</p>
              <p class="titleWindowsListDetail">{{this.restrictionsRegion | regionsFormat}}</p>
              <ul class="windowsList">
                <li v-for="(value, key) in restrictionsDetail"
                    v-bind:key="key.restrictionsDetail">
                   <span style="color: #AAD500; width: 40px; display: block; float: left">
                     DIA :
                   </span>
                 <span style="width: 100px; display: block; float: left">
                     {{ value.dayRes }}
                   </span>
                 <span style="color: #AAD500;width: 50px; display: block; float: left">
                     DESDE :
                   </span>
                 <span style="width: 60px; display: block; float: left">
                     {{value.init | dateFormat}}
                   </span>
                 <span style="color: #AAD500; width: 50px; display: block; float: left">
                     HASTA  :
                   </span>
                 <span style="width: 60px; display: block; float: left">
                     {{value.finish | dateFormat}}
                   </span>
                </li>
              </ul>
              <!--
              <el-button class="el-icon-edit primary colorBtn"
                         size="mini"
                         @click="addPoligon">&#160;EDITAR ZONA
              </el-button>
              <el-button class="colorBtn primary"
                         size="mini"
                         @click="clickSendZone">GUARDAR ZONA RESTRICCIÓN
              </el-button>
              -->
            </div>
          </el-col>
        </el-row>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>

import moment from 'moment';
import { apiRequest } from '../../backend/vue-axios/axios';
import BaseSelectRegion from './BaseSelectRegion.vue';

export default {
  name: 'ZonesFormModify',
  components: {
    BaseSelectRegion,
  },
  data() {
    return {
      // todo: Ver por localidades, utilizar búscador google maps
      regionCords: [
        {
          id: 1, // Tarapaca OK
          lng: -69.808079,
          lat: -20.200882,
          zoom: 8,
        },
        {
          id: 2, // Antofagasta OK
          lng: -70.394431,
          lat: -23.627096,
          zoom: 7,
        },
        {
          id: 3, // Atacama OK
          lng: -70.612726,
          lat: -27.046011,
          zoom: 7,
        },
        {
          id: 4, // Coquimbo OK
          lng: -71.338516,
          lat: -29.961246,
          zoom: 9,
        },
        {
          id: 5, // Valpo OK
          lng: -71.635253,
          lat: -33.031276,
          zoom: 12,
        },
        {
          id: 6, // L B O'higgins OK
          lng: -71.826346,
          lat: -34.363218,
          zoom: 10,
        },
        {
          id: 7, // Maule OK
          lng: -72.356081,
          lat: -35.415902,
          zoom: 8,
        },
        {
          id: 8, // Biobio OK
          lng: -73.197049,
          lat: -37.212972,
          zoom: 10,
        },
        {
          id: 9, // Araucanía OK
          lng: -73.241713,
          lat: -38.744875,
          zoom: 8,
        },
        {
          id: 10, // Los Lagos OK
          lng: -73.572665,
          lat: -40.71588,
          zoom: 8,
        },
        {
          id: 11, // Aysén OK
          lng: -74.089966,
          lat: -46.375856,
          zoom: 7,
        },
        {
          id: 12, // Magallanes OK
          lng: -72.599954,
          lat: -53.133935,
          zoom: 7,
        },
        {
          id: 13, // RM OK
          lng: -70.818046,
          lat: -33.471274,
          zoom: 9,
        },
        {
          id: 14, // Los Ríos
          lng: -73.167895,
          lat: -39.759730,
          zoom: 9,
        },
        {
          id: 15, // Arica y Parinacota OK
          lng: -70.054344,
          lat: -18.677916,
          zoom: 9,
        },
        {
          id: 16, // Todo: Falta Regíon Ñuble en base de datos
          lng: -72.5072355,
          lat: -36.6020576,
          zoom: 9,
        },
      ],
      days: [
        {
          label: 'Lunes',
          value: 1,
        },
        {
          label: 'Martes',
          value: 2,
        },
        {
          label: 'Miércoles',
          value: 3,
        },
        {
          label: 'Jueves',
          value: 4,
        },
        {
          label: 'Viernes',
          value: 5,
        },
        {
          label: 'Sábado',
          value: 6,
        },
        {
          label: 'Domingo',
          value: 7,
        },
      ],
      form: {
        zoneName: '',
        radio: [],
        selected: [],
        date: '',
        init: '',
        finish: '',
      },
      dataZones: [],
      dialogVisible: false,
      timeWindows: [],
      regionId: 0,
      props: {
        polygon: {
          type: String,
          required: true,
        },
      },
      nameTab: 'createZone',
      showDetail: false,
      errorsForm: {
        zoneName: '',
        select: '',
        selected: '',
        init: '',
        finish: '',
        initValidate: '',
        finishValidate: '',
      },
      windowsCreated: false,
      restrictions: [],
      loadingCreateWindows: false,
      loadCreateZone: false,
      showAddZone: false,
      loadingTable: false,
      restrictionsDetail: [],
      restrictionsName: '',
      restrictionsRegion: '',

    };
  },
  filters: {
    daysFormat(id) {
      const days = ['', 'L', 'M', 'MI', 'J', 'V', 'S', 'D'];
      const result = [];
      if (id.length > 0) {
        id.forEach((e) => {
          result.push(days[e.id]);
        });
      } else {
        for (let i = 1; i < 8; i += 1) {
          result.push(days[i]);
        }
      }
      return result.join('-');
    },
    regionsFormat(id) {
      const regions = ['', 'Región de Tarapacá', 'Región de Antofagasta', 'Región de Atacama',
        'Región de Coquimbo', 'Región de Valparaíso',
        'Región del Libertador General Bernardo O’Higgins', 'Región del Maule',
        'Región del Biobío', 'Región de La Araucanía', 'Región de Los Lagos',
        'Región de Aysén del General Carlos Ibáñez del Campo',
        'Región de Magallanes y la Antártica Chilena', 'Región Metropolitana de Santiago',
        'Región de Los Ríos', 'Región de Arica y Parinacota', 'Región del Ñuble'];
      const result = regions[id];
      return result;
    },
    dateFormat(date) {
      return moment.utc(date).format('LT');
    },
  },
  methods: {
    showZone(data) {
      this.$emit('submit', data.row.polygon);
      this.showDetail = true;
      this.nameTab = 'detail';
      const rowDetail = data.row.restrictions;
      this.restrictionsDetail = [];
      this.restrictionsName = data.row.name;
      this.restrictionsRegion = data.row.regions_id;
      rowDetail.forEach((e) => {
        const daysDetail = {};
        // eslint-disable-next-line
        daysDetail.dayRes = e["days"].day_name;
        daysDetail.init = e.time_windows.time_init;
        daysDetail.finish = e.time_windows.time_finish;
        daysDetail.id = e.time_windows.id;
        this.restrictionsDetail.push(daysDetail);
      });
    },
    handleTab(tab) {
      if (tab.name === 'editZone' || tab.name === 'createZone') {
        this.showDetail = false;
      }
      // PRUEBA BORRAR POLIGONO AL PRESIONAR CREATE ZONE
      if (tab.name === 'createZone') {
        this.$emit('cleanPoly');
      }
      if (tab.name === 'createZone' || tab.name === 'editZone') {
        this.restrictionsDetail = [];
        this.restrictionsName = '';
        this.restrictionsRegion = '';
      }
    },
    changeStatus(row) {
      this.$message({
        message: `Cambiando estado de restricción, Nombre: ${row.name}`,
        duration: 8000,
        showClose: true,
      });
      apiRequest({
        module: 'crud',
        service: 'change_status_zones',
        params: {
          name: row.name,
          polygon: row.polygon,
          regions_id: row.regions_id,
          active: row.active,
        },
        pathparam: {
          id: row.id,
        },
      }).then(() => {
        this.$notify({
          type: 'success',
          title: 'OK',
          message: `Estado modificado de restricción ${row.name}`,
        });
        this.getZone({ limit: 100 });
        // this.dataZones = data.data;
      }).catch(() => {
        this.$notify({
          type: 'error',
          title: 'Error',
          message: 'Error al cambiar el estado de la zona.',
        });
      });
    },
    deleteZone(row) {
      this.$message({
        message: `Eliminando restricción, ${row.name}`,
        duration: 8000,
        showClose: true,
      });
      apiRequest({
        module: 'crud',
        service: 'delete_zone',
        pathparam: {
          id: row.id,
        },
      }).then(() => {
        this.$notify({
          type: 'success',
          title: 'OK',
          message: `Restricción ${row.name} eliminada`,
        });
        this.getZone({ limit: 100 });
        this.$emit('cleanPoly');
        // this.dataZones = data.data;
      }).catch(() => {
        this.$notify({
          type: 'error',
          title: 'Error',
          message: 'Error al eliminar la zona.',
        });
      });
    },
    receiveTimeWindows(data) {
      this.timeWindows.push(data);
    },
    deletePolyMap() {
      this.$emit('cleanPoly');
    },
    receiveRegionId(data) {
      this.regionId = data;
      if (this.regionId === -1) {
        this.errorsForm.select = 'Región requerida';
      } else {
        this.errorsForm.select = '';
        const dataRegion = this.regionCords.find(e => e.id === this.regionId);
        if (dataRegion.length === 0) {
          this.$emit('centerMap', -70.6200875, -33.4715608, 8);
        } else {
          this.$emit('centerMap', dataRegion.lng, dataRegion.lat, dataRegion.zoom);
        }
      }
    },
    getZone() {
      this.loadingTable = true;
      apiRequest({
        module: 'crud',
        service: 'get_zones',
        params: { limit: 100 },
      }).then((data) => {
        this.dataZones = data.data;
        this.loadingTable = false;
      }).catch(() => {
        this.$notify({
          type: 'error',
          title: 'Error',
          message: 'Error al crear la zona.',
        });
        this.loadingTable = false;
      });
    },
    // FORM
    addPoligon() {
      this.$emit('addPoligon', true);
      this.showAddZone = true;
    },
    datePickerVal() {
      // todo: CALENDARIO FECHA O FECHAS ESPECIFICO/ PENDIENTE SERVICIO
    },
    lostFocus() {
      if (this.form.zoneName.trim() === '') {
        this.errorsForm.zoneName = 'Nombre zona requerido';
      } else {
        this.errorsForm.zoneName = '';
      }
    },
    lostInit() {
      if (this.form.init === null) {
        this.errorsForm.init = 'Hora de inicio es requerida';
      } else {
        this.errorsForm.init = '';
      }
    },
    lostFinish() {
      if (this.form.finish === null) {
        this.errorsForm.finish = 'Hora de término es requerida';
      } else {
        this.errorsForm.finish = '';
      }
    },
    deleteWindows(i) {
      this.timeWindows.splice(i, 1);
    },
    changeOptionDay() {
      this.form.selected = [];
    },
    validateHours() {
      if (this.form.finish !== null && this.form.init > this.form.finish) {
        this.errorsForm.initValidate = 'Debe ser menor a hora de fin';
      } else {
        this.errorsForm.initValidate = '';
      }
      if (this.form.init !== null && this.form.init > this.form.finish) {
        this.errorsForm.finishValidate = 'Debe ser mayor a hora de inicio';
      } else {
        this.errorsForm.finishValidate = '';
      }
    },
    submit() {
      this.validateHours();
      if (this.errorsForm.finishValidate === '' || this.errorsForm.initValidate === '') {
        if (this.form.zoneName === '' || this.form.init === '' || this.form.finish === '') {
          this.alertForm();
          this.$notify({
            title: 'Advertencia',
            message: 'El formulario no puede tener campos vacíos o errores de fecha',
            type: 'warning',
          });
        } else {
          this.loadingCreateWindows = true;
          this.checkTimeWindows();
        }
      } else {
        this.$notify({
          title: 'Advertencia',
          message: 'Fecha inicio inferior a fecha de termino',
          type: 'warning',
        });
      }
    },
    alertForm() {
      this.errorsForm.zoneName = (this.form.zoneName === '') ? 'Nombre zona requerido' : '';
      this.errorsForm.select = (this.form.select === '') ? 'Región requerida' : '';
      // eslint-disable-next-line
      this.errorsForm.selected = (this.form.selected.length === 0) ? 'Selecciónar días es requerido' : '';
      this.errorsForm.init = (this.form.init === '' || this.form.init === null) ? 'Hora de inicio es requerida' : '';
      // eslint-disable-next-line
      this.errorsForm.finish = (this.form.finish === '' || this.form.finish === null) ? 'Hora de término es requerida' : '';
    },
    valueOption(val) {
      if (val.length === 0) {
        this.errorsForm.selected = 'Selecciónar días es requerido';
      } else {
        this.errorsForm.selected = '';
      }
    },
    checkTimeWindows() {
      apiRequest({
        module: 'crud',
        service: 'get_time_windows',
        params: {
          time_windows_time_init: `2006-06-27T${this.form.init}:00Z`,
          time_windows_time_finish: `2006-06-27T${this.form.finish}:00Z`,
        },
      }).then((response) => {
        if (response.data.length) {
          this.sendEvent(response.data[0], this.form.selected);
        } else {
          this.addTimeWindows();
        }
      }).catch(() => {
        this.$notify({
          type: 'error',
          title: 'Error',
          message: 'Error en la consulta.',
        });
      });
    },
    addTimeWindows() {
      apiRequest({
        module: 'crud',
        service: 'add_time_windows',
        params: {
          time_init: `2006-01-02T${this.form.init}:00Z`,
          time_finish: `2006-01-02T${this.form.finish}:00Z`,
        },
      }).then((response) => {
        this.sendEvent(response.data, this.form.selected);
      }).catch(() => {
        this.$notify({
          type: 'error',
          title: 'Error',
          message: 'Error en la consulta.',
        });
      });
    },
    sendEvent(tw, days) {
      // eslint-disable-next-line
      delete tw.restrictions;
      if (days.length === 0) {
        this.receiveTimeWindows({
          timeWindows: {
            days: this.days.map(el => ({ id: el.value })),
            time_window: tw,
          },
        });
      } else {
        this.receiveTimeWindows({
          timeWindows: {
            days: days.map(el => ({ id: el })),
            time_window: tw,
          },
        });
      }
      this.$notify({
        title: 'Ventana horaria creada',
        message: 'Dibuja zona de restricción',
        type: 'success',
      });
      this.loadingCreateWindows = false;
    },
    cleanForm(type) {
      if (type === 'after create zone') {
        this.form.zoneName = '';
        this.form.radio = [];
        this.form.select = [];
        this.form.date = '';
        this.form.init = '';
        this.form.finish = '';
        this.timeWindows = [];
        this.restrictions = [];
        this.dataZones = [];
      }
    },
    // ENVIAR ZONA
    clickSendZone() {
      this.$emit('clickSendZone');
    },
    sendZone(data) {
      if (data === '' || data === null) {
        this.$notify({
          type: 'warning',
          title: 'Error',
          message: 'Debe dibujar la zona de restricción',
        });
      } else {
        const timeW = this.timeWindows;
        const timeWind = [];
        timeW.forEach((e) => {
          timeWind.push(e.timeWindows);
        });
        this.loadCreateZone = true;
        apiRequest({
          module: 'planning',
          service: 'add_zone',
          params: {
            zone: {
              name: this.form.zoneName,
              polygon: data,
              regions_id: this.regionId,
              active: true,
            },
            schedule: timeWind,
          },
        }).then(() => {
          this.$emit('cleanPoly');
          this.$notify({
            title: 'Completado',
            message: 'Zona agregada con éxito.',
            type: 'success',
          });
          this.loadCreateZone = false;
          this.getZone({ limit: 100 });
          this.cleanForm('after create zone');
          this.showAddZone = false;
        }).catch(() => {
          this.$notify({
            type: 'error',
            title: 'Error',
            message: 'Error al crear la zona',
          });
          this.loadCreateZone = false;
        });
      }
    },
  },
  created() {
    this.getZone({ limit: 100 });
  },
};
</script>

<style lang="scss" scoped>
  .colorBtn {
    background-color: $fb-green !important;
    border-color: $fb-green !important;
    color: #FFFFFF !important;
    border-radius: 0 !important;
    &:hover {
      background-color: $fb-green-dark-10 !important;
      color: #FFFFFF !important;
    }
  }
  .colorBtnDraw {
    background-color: $fb-green-dark-10 !important;
    border-color: $fb-green !important;
    color: #FFFFFF !important;
    border-radius: 0 !important;
    &:hover {
      background-color: $fb-green !important;
      color: #FFFFFF !important;
    }
  }
  .parpadeo {
    animation-name: parpadeo;
    animation-duration: 1s;
    animation-timing-function: linear;
    animation-iteration-count: infinite;
    -webkit-animation-name:parpadeo;
    -webkit-animation-duration: 3s;
    -webkit-animation-timing-function: linear;
    -webkit-animation-iteration-count: infinite;
  }
  @-moz-keyframes parpadeo{
    0% { opacity: 1.0; }
    50% { opacity: 0.0; }
    80% { opacity: 1.0; }
  }
  @-webkit-keyframes parpadeo {
    0% { opacity: 1.0; }
    50% { opacity: 0.0; }
    80% { opacity: 1.0; }
  }
  @keyframes parpadeo {
    0% { opacity: 1.0; }
    50% { opacity: 0.0; }
    80% { opacity: 1.0; }
  }
  .collapsibleFormInputContainer {
   padding: 0px;
  }
  .btn.primary {
    float: right;
    margin-top: 1em;
  }
  .form-map-title{
    color: #707070;
    font-weight: normal;
    text-transform: uppercase;
    font-size: 12px;
  }
  button.el-button.plus {
    border-radius: 20px !important;
    background-color: $fb-green !important;
    border: none;
    margin-left: 1em;
  }
  .el-form.form-map-main .el-form-item:first-child {
    margin-bottom: 0;
  }
  .el-form-item.time-windows {
    display: flex;
    align-content: center;
    color: $fb-green;
  }
  .el-form-item.time-windows span {
    text-transform: uppercase;
    font-size: 10px!important;
    font-family: "Lato", sans-serif;
    font-weight: bold;
    margin-right: 1em;
  }
  .el-form-item.time-windows button {
    background-color: $fb-green;
    border: transparent;
    color: $fb-grey-light-97;
    &:focus {
      outline: none;
    }
    &:hover {
      background-color: $fb-green-dark-10;
    }
  }
  .el-dialog {
    z-index: 9999!important;
  }
  .alertForm {
    color: rgb(255, 145, 0);
    font-size: 12px;
  }
  .windowsCreated {
    padding: 0px;
    margin: 0px;
  }
  .windowsList {
    color: #9B9B9B;
    font-size: 12px;
    padding: 0;
  }
  .titleWindowsList {
    color: #AAD500;
    text-transform: uppercase;
    font-size: 10px;
    font-weight: 600;
    padding: 0;
    margin: 0;
  }
  .titleWindowsListDetail {
    color: #AAD500;
    text-transform: uppercase;
    font-size: 12px;
    padding: 0;
    margin-top: 5px;
  }
  .titleWindows{
    color: #AAD500;
    text-transform: uppercase;
    font-size: 14px;
  }
</style>
